angular.module('unica_location.location_services', []);